export const preRecoveryRoom = {
	intraoperative_transfusion: "",
	name_procedure_performed: "",
	correct_count: "",
	equipment_problems: "",
	number_pieces_freezing: "",
	surgical_specimen_identification: "",
	verified_bracelets: "",
	skin_to_skin_contact: "",
	responsible_professional_id: "",
};
